export const Modules = {
  UNIONS: 1,
  ACTIVITIES: 2,
  GROUPS: 3,
}
